import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import { useScrollAnimation } from '../AnimatedSection/useScrollAnimation';
import styles from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import getLocal from 'eco-design-reliance/getLocal';

const GraphicText: React.FC = () => {
    const { t } = useLang('GraphicText');
    const { locale = 'us' } = getLocal();
    const isEu = ['eu', 'de', 'uk', 'fr', 'es', 'it', 'nl'].includes(locale)
    const titleAnimation = useScrollAnimation('fadeInUp', { delay: 0 });
    const descAnimation = useScrollAnimation('fadeInUp', { delay: 200 });
    const imageAnimation = useScrollAnimation('fadeInUp', { delay: 400 });
    return (
        <div className={`${styles.GraphicText} ${isEu ? 'range4' : "range5"}  GtmModuleData-section`} data-section-id="d3c-GraphicText" id="CompactAndPortable">
            {!isEu && locale !== 'uk' && <EcoSpace />}
            <div className="container">
                <div className="textContent">
                    <h2 className="title" ref={titleAnimation.ref as React.RefObject<HTMLHeadingElement>} style={titleAnimation.animationStyle}>
                        {t('title')}
                    </h2>
                    <p className="desc" ref={descAnimation.ref as React.RefObject<HTMLParagraphElement>} style={descAnimation.animationStyle}>
                        {t('desc')}
                    </p>
                </div>
                <div className="imageContent" ref={imageAnimation.ref as React.RefObject<HTMLDivElement>} style={imageAnimation.animationStyle}>
                    <EcoImg
                        isOpenLazy={true}
                        pc={isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1773904505687/pc-111.jpg" : 'https://websiteoss.ecoflow.com/upload/image/1773904549615/pc-1-1.jpg') : "https://websiteoss.ecoflow.com/upload/image/1757578732581/compact.jpg"}
                        h5={isEu ? (locale === 'uk' ? "https://websiteoss.ecoflow.com/upload/image/1773904527379/m-111.jpg" : 'https://websiteoss.ecoflow.com/upload/image/1773904549280/m-1-1.jpg') : "https://websiteoss.ecoflow.com/figma-uploads/1759060208457-hau61c-compressed-Charge%20up%2C%20fast%2C%20and%20everywhere.jpg"}
                    />
                </div>
            </div>
            <EcoSpace />
        </div>
    );
};

export default GraphicText;
